import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { auth } from '@shared/api/services';
import { Login } from '@widgets/auth/ui/login/login';
import { persistStudentOnboardingPrefillSearch } from '@pages/student/onboarding/lib/student-onboarding-prefill';


export const LoginPage = () => {
	const [error, setError] = useState('')

	const [params] = useSearchParams();
	const username = params.get('username')
	const password = params.get('password')
	const teacher_id = params.get('teacher_id')

	const methods = useForm({
		defaultValues: {phone: username || '', password: password || ''},
		mode: 'onTouched'
	})

	const { formState } = methods

  const handleSubmit = methods.handleSubmit(data => {
		const loginPayload = {
			phone: data.phone,
			password: data.password
		}

		persistStudentOnboardingPrefillSearch(window.location.search)
	
		auth.login(loginPayload, teacher_id).catch((response) => {
			if(response?.response){
				setError(response.response)
			}else{
				setError({localMessage: 'Ошибка сети'})
			}
		})
  })

	useEffect(() => {
		if(username && password){
			const loginPayload = {
				phone: username,
				password: password
			}

			persistStudentOnboardingPrefillSearch(window.location.search)
		
			auth.login(loginPayload, teacher_id).catch((response) => {
				if(response?.response){
					setError(response.response)
				}else{
					setError({localMessage: 'Ошибка сети'})
				}
			})
		}
	}, [username, password, teacher_id])

	return <Login {...{handleSubmit, error, methods, formState}}/>
}
